import { Header } from 'antd/es/layout/layout';
import React from 'react';
import { getToken } from './token.service';
const HeaderComponent = () => {
    function checkAndRedirect() {
        const currentPath = window.location.pathname;
        const token = getToken(); // Assuming token is stored in localStorage
    
        if (currentPath !== '/login' && !token) {
            window.location.href = '/login';
        }
    }

    checkAndRedirect();
    return (
        <Header>
            <div>
                <span style={{ color: 'white', fontSize: '25px', fontWeight: 'bold' }}>RESUME ANALYZER</span>
            </div>
        {/* <h1 >Resume Analyzer</h1> */}
        </Header>
    );
}

export default HeaderComponent;